//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { checkAuthor } from '@/utils/utils'
import Hint from '~/components/other/Hint'
import Button from '~/components/other/Button'

export default {
  components: {
    Hint
  },
  runtimeCompiler: true,
  props: {
    masterpiece: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      hint: null,
      hintsText: {},
      width: 0,
    }
  },
  computed: {
    getCurrentSize() {
      const { size } = this.masterpiece
      let result = []
      if (size.height) {
        result.push(size.height)
      }
      if (size.width) {
        result.push(size.width)
      }
      if (size.depth) {
        result.push(size.depth)
      }
      return result.join(' x ')
    }
  },
  mounted() {
    this.findAllLinks();
    this.getRelatedMasterpiece();
    this.width = document.body.clientWidth;
  },
  methods: {
    useLink(link) {
      window.location.href = link
    },
    checkVerification(item, author) {
      return checkAuthor(item, author)
    },
    arrayToText(array) {
      return array.map(element => element.name).join(', ');
    },
    getTextArr(content) {
      // return getArrForTitle(content)
      const arr = content.split('\n')

      return arr
    },
    async getRelatedMasterpiece() {
      if (this.$refs.related) {
        const links = this.$refs.related.querySelectorAll('.misObjectSelected')
        for (const link of links) {
          const misId = link.getAttribute('misid')
          if (misId) {
            const id = await this.$axios({
              method: 'get',
              url: `/api/v1/gallery/getIdByMisId?misId=${misId}`,
            })
            if (id.data.data) {
              link.href = `/app/masterpiece/${id.data.data}`
            }
          }
        }
      }
    },
    async findAllLinks() {
      // const links = this.$refs.description.querySelectorAll('a')
      if (this.$refs.description) {
        const links = this.$refs.description.querySelectorAll('.misObjectSelected')
        for (const link of links) {
          const misId = link.getAttribute('misid')
          if (misId) {
            const id = await this.$axios({
              method: 'get',
              url: `/api/v1/gallery/getIdByMisId?misId=${misId}`,
            })
            if (id.data.data) {
              link.href = `/app/masterpiece/${id.data.data}`
            }
          }
        }
        const hintLinks = this.$refs.description.querySelectorAll('.term')
        for (const link of hintLinks) {
          const misId = link.getAttribute('termid')
          if (misId) {
            const res = await this.$axios({
              method: 'get',
              url: `/api/v1/term/getByMisId?misId=${misId}&lang=${this.$i18n.locale || 'ru'}`,
            })
            if (res.data.data && res.data.data.length) {
              this.hintsText[misId] = res.data.data[0].description
            }
          }
        }
      }
    },
    async handleMouseMove(e) {
      if (e.target.className === 'term'){
        const misId = e.target.getAttribute('termid')
        if (this.hintsText.hasOwnProperty(misId)) {
          this.hint = this.hintsText[misId]
        }
      } else if (e.target.className === 'misObjectSelected' && !e.target.href) {
        this.hint = this.$i18n.locale === 'en' ? 'Users have not revealed this masterpiece yet' : 'Пользователи еще не открыли этот шедевр'
      } else if (this.hint) {
        this.hint = null
      }
    }
  },
}
